import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, Compass } from 'lucide-react';
import prophecyLogoDark from '../../Recruitment/Assets/images/PROPHECY-LOGO-DARK.png';
import prophecyLogo from '../../Recruitment/Assets/images/prophecy-logo.png';

const DemoNavbar = () => {
  const navigate = useNavigate();

  return (
    <header className="erp-demo-navbar">
      <div className="erp-demo-navbar-inner">
        {/* Left: Prophecy Logo Group */}
        <div className="erp-demo-logo-group" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img src={prophecyLogoDark} alt="Prophecy Logo Icon" className="erp-demo-logo-img" />
          <img src={prophecyLogo} alt="Prophecy Technologies" className="erp-demo-logo-text-img" />
        </div>

        {/* Right Action Buttons (Nav tabs removed per user request) */}
        <div className="erp-demo-nav-actions">
          <button
            type="button"
            className="erp-demo-btn-secondary"
            onClick={() => navigate('/careers')}
            title="Visit public careers portal"
          >
            <Compass size={15} />
            <span>Careers Portal</span>
          </button>

          <button
            type="button"
            className="erp-demo-btn-primary"
            onClick={() => navigate('/login')}
            title="Log in to Prophecy Nexus"
          >
            <LogIn size={15} />
            <span>Sign In to Nexus</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default DemoNavbar;
